import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import WeddingStorySeo from '@/components/feature/WeddingStorySeo'
import WeddingStorySection from '@/components/feature/sections/WeddingStorySection'
import WeddingStoryTimelineSection from '@/components/feature/sections/WeddingStoryTimelineSection'
import GallerySection from '@/components/feature/sections/GallerySection'
import RelatedStoriesSection from '@/components/feature/sections/RelatedStoriesSection'
import CtaBand from '@/components/feature/CtaBand'
import { storyGalleryItems, storyGalleryCategories } from '@/mocks/weddingStory'

export default function WeddingStory() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <WeddingStorySeo />
      <PageHeader
        breadcrumb={t('weddingStory.breadcrumb')}
        label={t('weddingStory.label')}
        title={t('weddingStory.title')}
        description={t('weddingStory.description')}
        image="https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20temple%20wedding%20mandapam%20with%20the%20bride%20and%20groom%20in%20traditional%20attire%2C%20marigold%20and%20jasmine%20floral%20decor%2C%20warm%20golden%20light%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=1920&height=900&seq=shabi-hdr-story&orientation=landscape"
        imageAlt="Aarthi and Karthik's temple wedding in Madurai photographed by Shabi Media"
      />
      <WeddingStorySection />
      <WeddingStoryTimelineSection />
      <GallerySection
        items={storyGalleryItems}
        categories={storyGalleryCategories}
        namespace="weddingStory.gallery"
        showFooter={false}
      />

      <RelatedStoriesSection currentSlug="aarthi-karthik" />

      <CtaBand
        eyebrow={t('weddingStory.cta.eyebrow')}
        title={t('weddingStory.cta.title')}
        description={t('weddingStory.cta.description')}
      />
    </SiteLayout>
  )
}